module.exports = __webpack_public_path__ + "img/9.58a2f699.png";